import React, { Component } from "react";
import Table from "../Table";
import { Link } from "react-router-dom";
import moment from "moment";
import formatName from "../../util/formatName";
import DataTable from "react-data-table-component";

class WebhooksTable extends Component {
  state = {
    cobrand: this.props.cobrand,
    data: [],
    rowsPerPage: 10
  };

  render() {
    const title = "Webhooks";
    const columns = [
      {
        name: "Webhook ID",
        selector: "payload.id",
        sortable: true,
        ignoreRowClick: true,
        minWidth: "300px",
        cell: row => {
          return (
            <React.Fragment>
              <Link
                to={{
                  pathname:
                    "/webhooks/" + this.props.cobrand.id + "/" + row.payload.id,
                  state: [
                    ...this.props.data.filter(
                      payload => payload.id === row.payload.id
                    )
                  ]
                }}
              >
                {row.payload.id}
              </Link>
            </React.Fragment>
          );
        }
      },
      {
        name: "Application ID",
        selector: "payload.applicationId",
        sortable: true,
        ignoreRowClick: true,
        maxWidth: "20%"
      },
      {
        name: "Login Name",
        selector: "payload.loginName",
        sortable: true,
        ignoreRowClick: true,
        maxWidth: "280px",
        cell: row => {
          return (
            <span title={row.payload.loginName}>{row.payload.loginName}</span>
          );
        }
      },
      {
        name: "Delivery Status",
        selector: "deliveryStatus",
        sortable: true,
        ignoreRowClick: true,
        maxWidth: "14%",
        cell: row => {
          return (
            <span className="nameLabel" title={row.deliveryStatus}>
              {formatName(row.deliveryStatus)}
            </span>
          );
        }
      },
      {
        name: "Dispatch Time",
        selector: "payload.timeStamp",
        sortable: true,
        ignoreRowClick: true,
        maxWidth: "14%",
        cell: row => {
          return (
            <span>
              {moment
                .utc(row.payload.timeStamp)
                .local()
                .format("MM-DD-YYYY HH:mm")}
            </span>
          );
        }
      }
    ];
    return (
      <DataTable
        title={title}
        columns={columns}
        data={this.props.data}
        responsive
        pagination
        paginationServer
        paginationRowsPerPageOptions={[25, 50, 75, 100]}
        paginationPerPage={this.props.paginationPerPage}
        paginationTotalRows={this.props.totalCount}
        onChangeRowsPerPage={this.props.handlePerRowsChange}
        onChangePage={this.props.handlePageChange}
      />
    );
  }
}

export default WebhooksTable;
